module.exports = __webpack_public_path__ + "static/media/backend.d7a40c56.png";